const rev = () => window._version || 'a2958ec16247ad'

const revision = rev()

const useSpriteIcon = (icon, svguse = false, sprite = 'sprite') =>
  `${svguse ? 'svguse:' : ''}/sprites/symbol/${sprite}.svg?rev=${revision}#${icon}`

const useSpriteIconBlog = (icon) => useSpriteIcon(icon, false, 'blog')

export { rev, useSpriteIcon, useSpriteIconBlog}
